import React from 'react';
import { Award, Check } from 'lucide-react';

/**
 * Компонент секции программы лояльности
 */
const LoyaltyParamsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  loyaltyStatuses 
}) => {
  // Если секция программы лояльности не активирована, показываем только чекбокс
  if (!formData.hasLoyaltyStatus) {
    return (
      <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="hasLoyaltyStatus"
            checked={formData.hasLoyaltyStatus}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-base font-medium text-gray-900 dark:text-white flex items-center">
            <Award className="w-5 h-5 mr-2 text-amber-500" />
            Учитывать статус в программе лояльности
          </span>
        </label>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
      <div className="flex items-center justify-between mb-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="hasLoyaltyStatus"
            checked={formData.hasLoyaltyStatus}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-base font-medium text-gray-900 dark:text-white flex items-center">
            <Award className="w-5 h-5 mr-2 text-amber-500" />
            Статус в программе лояльности
          </span>
        </label>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mt-2">
        {loyaltyStatuses.map((status) => {
          const isSelected = formData.loyaltyStatus === status.id;
          
          return (
            <label 
              key={status.id}
              className={`
                p-3 rounded-lg border cursor-pointer transition-colors
                ${isSelected
                  ? 'bg-amber-100 border-amber-300 dark:bg-amber-900/30 dark:border-amber-700' 
                  : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-650'}
              `}
            >
              <div className="flex items-start">
                <input
                  type="radio"
                  name="loyaltyStatus"
                  value={status.id}
                  checked={isSelected}
                  onChange={handleInputChange}
                  className="form-radio mt-1"
                />
                <div className="ml-2">
                  <span className="block text-sm font-medium text-gray-900 dark:text-white">
                    {status.name}
                  </span>
                  <span className="block text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    {status.description}
                  </span>
                </div>
              </div>
            </label>
          );
        })}
      </div>
      
      {errors.loyaltyStatus && (
        <p className="mt-2 text-xs text-red-500 dark:text-red-400">
          {errors.loyaltyStatus}
        </p>
      )}
      
      <div className="mt-4 bg-amber-100 dark:bg-amber-900/30 p-3 rounded-lg border border-amber-200 dark:border-amber-800">
        <p className="text-sm text-amber-700 dark:text-amber-300">
          <span className="font-medium">Преимущества:</span> Участники программы лояльности получают 
          дополнительные привилегии по багажу в зависимости от уровня.
          Это может включать увеличенную норму веса или дополнительное место багажа.
        </p>
      </div>
    </div>
  );
};

export default LoyaltyParamsSection;